import {
  HStack,
  colors,
  customEvent,
  responsive,
  kakaoPixel,
  pixelCustomEvent,
  PixelEventName,
  daangnPixelTrack,
  tossPixel,
  NextLink,
  Button,
  VStack,
  useResponsive,
  tiktokPixelTrack,
} from "goi_common";
import { Box } from "@chakra-ui/react";
import { naverConversionEvent } from "@/utils/naverPageView";

export default function LandingFixedTwinButton({
  href = "/registration/info/",
  text,
  leftText,
  color = colors.orange650,
  onCtaClick,
}: {
  text?: string;
  leftText?: string;
  color?: string;
  href?: string;
  onCtaClick?: () => void;
}) {
  const { isBiggerThanLg } = useResponsive();
  return (
    <VStack
      css={responsive({
        position: "fixed",
        bottom: 0,
        zIndex: 10,
        width: "100%",
        background: { base: colors.white, lg: colors.gray50 },
        alignItems: "center",
      })}
    >
      <HStack
        css={responsive({
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          padding: { base: "18px 20px", lg: "20px 0px" },
          maxWidth: "1200px",
        })}
      >
        <Box className="gray900 subtitle_21_m lg_under_hidden">
          {leftText ||
            "평생 지금 가격 그대로 보장받는 상조, 100원으로 시작하기"}
        </Box>
        <HStack
          gap={isBiggerThanLg ? "16px" : "8px"}
          css={responsive({
            width: { base: "100%", lg: "auto" },
          })}
        >
          <NextLink
            href={href || "/registration/info/"}
            css={responsive({ width: { base: "100%", lg: "auto" } })}
          >
            <Button
              className="body_16_m md_head_24_m"
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "home",
                    trigger_and_target: "CTA",
                  },
                });
                customEvent({
                  newGtm: {
                    path: "home",
                    trigger_and_target: "fixed_CTA",
                  },
                });

                naverConversionEvent({ type: "view_product" });
                onCtaClick?.();
                kakaoPixel()?.participation();
                tossPixel()?.productView();
                daangnPixelTrack("ViewContent");
                tiktokPixelTrack("ViewContent");
                pixelCustomEvent(PixelEventName.ViewContent);
              }}
              css={responsive({
                width: { base: "100%", lg: "auto" },
                border: `1px solid ${color}`,
                borderRadius: "6px",
                background: color,
                color: colors.white,
                padding: { base: "12px 0px", lg: "16px 46px" },
              })}
            >
              {text || "3분만에 간편가입"}
            </Button>
          </NextLink>
        </HStack>
      </HStack>
    </VStack>
  );
}
